export const BannerImage = {
  "& img": {
    maxWidth: { xl: "750px", md: "660px", sm: "450px", xs: "300px" },
    width: "100%",
  },
};
